module.exports = __webpack_public_path__ + "img/cube-03.5b3c9ad6.svg";